module.exports = __webpack_public_path__ + "img/tarjeta_100_euros_viajar_participacion.0628fb8f.jpg";